import type { TData } from "@package/grid-utils";
import type { GridApi } from "ag-grid-community";

import type { TConditionalFormattingRule } from "../../../data";
import { rowIdToPeriod } from "../../../data/formatting/helpers";
import { getRowNodeFromPeriod } from "../cell-ref";

export const targetCells = (
  api: GridApi<TData> | null,
  rules: Pick<TConditionalFormattingRule, "column_id" | "row_id">[],
) => {
  if (!api) return;
  api.clearCellSelection();
  rules.forEach((rule) => {
    const period = rowIdToPeriod(rule.row_id);
    const rowNode = getRowNodeFromPeriod(api, rule.row_id) ?? (period ? getRowNodeFromPeriod(api, period) : null);
    if (!rowNode) return;
    api.ensureColumnVisible(rule.column_id);
    api.ensureNodeVisible(rowNode);
    api.addCellRange({
      rowStartIndex: rowNode?.rowIndex,
      rowEndIndex: rowNode?.rowIndex,
      columnStart: rule.column_id,
      columnEnd: rule.column_id,
    });
  });
};
